/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import SummaryCard from '../../../common/SummaryCard/SummaryCard';
import { actionTypes } from '../../../common/SummaryCard/CardContext';
import SummaryMinicard from '../../../common/SummaryCard/SummaryMinicard';
import { mapEntityFields } from '../../../../shared/submission/entityFieldsMapper';
import { getIconComponent } from '../../../../shared/utils/iconUtils';

/**
 * Form array item summary card wrapper over the 2 size cards supported.
 */
export default function FormEntitySummaryCard({
  id,
  type,
  entity,
  config,
  openDeleteDialog,
  openEditDialog,
  readOnly = false,
  className,
  schema,
  formContext,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const { entries, cardTitle, icon, actions } = mapEntityFields(config, entity, schema, formContext);

  const handleActionsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditApplicant = () => {
    setAnchorEl(null);
    openEditDialog(entity.id);
  };

  const handleDeleteApplicant = () => {
    setAnchorEl(null);
    openDeleteDialog(entity.id);
  };

  return type === 'CARD' ? (
    <SummaryCard
      Icon={() => getIconComponent(icon)}
      cardTitle={cardTitle}
      subheader=""
      entries={entries}
      actionType={actionTypes.MENU}
      handleClick={handleActionsClick}
      handleEdit={openEditDialog ? handleEditApplicant : null}
      handleDelete={openDeleteDialog ? handleDeleteApplicant : null}
      handleClose={handleClose}
      anchorEl={anchorEl}
      readOnly={readOnly}
      id={id}
      className={className}
      schema={schema}
      enableTooltip={true}
      actions={actions}
    />
  ) : (
    <SummaryMinicard
      Icon={() => getIconComponent(icon)}
      sequenceNumber={entity.sequenceNumber}
      entries={entries}
      actionType={actionTypes.MENU}
      handleClick={handleActionsClick}
      handleEdit={openEditDialog ? handleEditApplicant : null}
      handleDelete={openDeleteDialog ? handleDeleteApplicant : null}
      handleClose={handleClose}
      anchorEl={anchorEl}
      readOnly={readOnly}
      id={id}
      className={className}
      schema={schema}
      actions={actions}
    />
  );
}
